export enum SocialMediaConstants {
    EMAIL = "mailto:BrandonNSaunders@gmail.com",
    LINKED_IN_URL = "https://www.linkedin.com/in/saundersbrandon/",
    GITHUB_URL = "https://github.com/SaundersB",
}
